import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import DisclaimerPopup from "@/components/DisclaimerPopup";
import HeroSection from "@/components/HeroSection";
import TrustBar from "@/components/TrustBar";
import DifferenceSection from "@/components/DifferenceSection";
import PracticeAreas from "@/components/PracticeAreas";
import WhyChoose from "@/components/WhyChoose";
import Partners from "@/components/Partners";
import Philosophy from "@/components/Philosophy";
import CaseResults from "@/components/CaseResults";
import ProcessTimeline from "@/components/ProcessTimeline";
import FAQ from "@/components/FAQ";
import CTASection from "@/components/CTASection";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import MobileCTA from "@/components/MobileCTA";
import useScrollAnimation from "@/hooks/useScrollAnimation";

function App() {
  useScrollAnimation();

  return (
    <div className="noise-overlay min-h-screen bg-navy-dark font-body">
      <DisclaimerPopup />
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: '#0A1628',
            border: '1px solid rgba(197,165,114,0.3)',
            color: '#F9FAFB',
          },
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <DifferenceSection />
        <PracticeAreas />
        <WhyChoose />
        <Partners />
        <Philosophy />
        <CaseResults />
        <ProcessTimeline />
        <FAQ />
        <CTASection />
        <ContactForm />
      </main>
      <Footer />
      <MobileCTA />
    </div>
  );
}

export default App;
